module.exports = __webpack_public_path__ + "static/media/anatomia.ae34ea31.png";